import { useTranslate } from "../../../../customHooks";
import { composeValidators, isAlphaNumeric, isRequired, maxLength } from "../../../../utils/validate";
import { ApplicationConfigManager, SupportedRegion } from "../../../../types";
import { useGetRegionsQuery } from "../../../../redux/services/regions-service";
import { useEffect, useState } from "react";
import { find } from "lodash";
import { Input, Select } from "@panwds/react-form";
import { useWatch } from "react-hook-form";
import { useFilteredPermissions } from "../../../../customHooks/useFilteredPermissions";

const Index = (props: any) => {
    const { setValue, control } = props
    const translate = useTranslate();
    const { filteredChangeProtectionOptions } = useFilteredPermissions();

    const hasGFA = find(filteredChangeProtectionOptions, { value: "GlobalFirewallAdmin" });

    if (hasGFA) {
        hasGFA.disabled = true;
    } else {
        filteredChangeProtectionOptions.push({
            children: "Global Firewall Admin",
            value: "GlobalFirewallAdmin",
            disabled: true
        })
    }

    const initChangeProtectionValue = filteredChangeProtectionOptions
        .filter((option: any) => option.value === "GlobalFirewallAdmin")
        .map((option: any) => option.value);

    const regionChanged = useWatch({
        control,
        name: "Region"
    });

    const { data: zones, error, isLoading: isZonesLoading, refetch: refetchZones } = useGetRegionsQuery(regionChanged, {
        skip: !regionChanged,
    });

    useEffect(() => {
        setValue("CustomerZoneIdList", undefined);
        if (zones) {
            refetchZones(); // Refetch zones when region changes if the query has been initiated
        }
    }, [regionChanged]);

    const regionItems = ApplicationConfigManager.getInstance().getSupportedRegions().map((region: SupportedRegion) => ({
        label: region.RegionDisplayName,
        value: region.RegionCode
    }));

    return (
        <div className="formLayout">
            <Input
                label={translate(`resources.firewallsV2.firewallName`)}
                name="FirewallName"
                dataMetrics="cloudngfw-firewall-create-name"
                requiredAsterisk
                placeholder="Enter a custom name for this firewall"
                register={{
                    validate: (value) => value === "" ||
                        composeValidators(isRequired,
                            isAlphaNumeric,
                            maxLength)(value)
                }}
            />
            <Select
                items={regionItems}
                label={translate(`resources.firewallsV2.region`)}
                name="Region"
                dataMetrics="cloudngfw-firewall-create-region"
                simpleFormat
                fitToItemWidth
                requiredAsterisk
            />
            <Select
                items={zones}
                label={translate(`resources.firewallsV2.availabilityZoneIDs`)}
                name="CustomerZoneIdList"
                dataMetrics="cloudngfw-firewall-create-availability-zone"
                simpleFormat
                fitToItemWidth
                requiredAsterisk
                enableMultiSelect
                isLoading={isZonesLoading}
                description="Select one or more Availability Zone IDs"
            />
            <Select
                items={filteredChangeProtectionOptions}
                label={translate(`resources.firewallsV2.changeProtection`)}
                name="ChangeProtection"
                dataMetrics="cloudngfw-firewall-create-delete-protection"
                simpleFormat
                fitToItemWidth
                requiredAsterisk
                enableMultiSelect
                defaultValue={initChangeProtectionValue}
                tooltip={translate(`resources.firewallsV2.fwCreate.changeProtectionTooltip`)}
            />
        </div>
    );
};
export default Index;
